import { Theme } from '@mui/material/styles'
import { CheckboxProps } from '@mui/material/Checkbox'
//
import { CheckboxIcon, CheckboxCheckedIcon, CheckboxIndeterminateIcon } from './CustomIcons'
import { onHover } from '../interaction'

// ----------------------------------------------------------------------

export default function Checkbox(theme: Theme) {
  return {
    MuiCheckbox: {
      defaultProps: {
        icon: <CheckboxIcon />,
        checkedIcon: <CheckboxCheckedIcon />,
        indeterminateIcon: <CheckboxIndeterminateIcon />,
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: CheckboxProps }) => ({
          padding: theme.spacing(1),
          // MUI computes a selection control's hover from its colour prop, and both
          // Checkbox and Radio default to `color="primary"` — which is navy. Every
          // checkbox in the app was hovering cool blue inside warm-grey chrome.
          ...onHover({ backgroundColor: theme.palette.action.hover }),
          // On-state is ink, never amber: amber is 1.54:1 on white and fails
          // the 3:1 control-boundary rule — amber means action, not state.
          // :not(.Mui-disabled) keeps MUI's disabled styling winning, so a
          // disabled checked control still reads as disabled.
          '&.Mui-checked:not(.Mui-disabled), &.MuiCheckbox-indeterminate:not(.Mui-disabled)': {
            color: theme.palette.text.primary,
          },
          ...(ownerState.size === 'small' && {
            '& svg': { width: 20, height: 20 },
          }),
          ...(ownerState.size === 'medium' && {
            '& svg': { width: 24, height: 24 },
          }),
        }),
      },
    },
  }
}
